export const LITEPICKER_BUTTON_TEXT = {
  // PhCaretLeft
  previousMonth:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="16px" height="16px" fill="currentColor"><g><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></g></svg>',

  // PhCaretRight
  nextMonth:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="16px" height="16px" fill="currentColor"><g><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></g></svg>',
};

export async function loadLitepicker(): Promise<Window['Litepicker']> {
  const module = await import('litepicker/dist/litepicker.umd');

  window.Litepicker = module.Litepicker;

  return window.Litepicker;
}
